<div class="container-fluid">
  <!-- Page Header with Action Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Student Liability Report</h1>

    <!-- Action Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button style="background-color: transparent !important; border: none;"
          (click)="onPrint()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print liability report"
          matTooltipPosition="below"
          aria-label="Print liability report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>

        <button
          style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="exportToCsv()">
          <mat-icon>file_download</mat-icon>
          <span>Export to CSV</span>
        </button>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Filter</mat-panel-title>
      </mat-expansion-panel-header>
      <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Date Range (As of Date)</mat-label>
              <input #dateRangeInput matInput
                [value]="dateRangeDisplayValue"
                placeholder="Select date range"
                readonly
                name="dateRange">
              <button matSuffix mat-icon-button type="button" (click)="openDateRangePicker()">
                <mat-icon>calendar_today</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Student Account</mat-label>
              <input
                #studentInput
                name="student_filter"
                (input)="onAutocompleteStudent($event)"
                matInput
                ngModel
                [matAutocomplete]="autoCompleteStudent"
                placeholder="Enter student name">
              <button (click)="redirectUserProfile(studentInput)" type="button" matSuffix mat-icon-button
                aria-label="manage_accounts">
                <mat-icon>manage_accounts</mat-icon>
              </button>
            </mat-form-field>
            <mat-autocomplete #autoCompleteStudent="matAutocomplete"
              (optionSelected)="onSubmit(f)">
              <mat-option
                *ngFor="let option of autoCompleteStudentAccountOptions"
                [value]="option.label">
                {{option.label}} ({{option.value}})
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Category Filter</mat-label>
              <mat-select [(ngModel)]="categoryFilter" name="category_filter"
                (selectionChange)="onSubmit(f)">
                <mat-option value="">All Departments</mat-option>
                <mat-option value="Front Dept">Front Dept</mat-option>
                <mat-option value="Middle Dept">Middle Dept</mat-option>
                <mat-option value="Back Dept">Back Dept</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <section class="section">
            <div class="float-end">
              <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
            </div>
          </section>
        </div>
      </form>
    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- Summary Cards: one tile per table column, in table-column order,
       fed from the server's full-set summary (never the page slice).
       Layout: 2/row on phones, 5/row on tablets, all 10 in one row >=1200px
       (col-xl equal-width overrides the row-cols width at xl). -->
  <div class="container-fluid mt-4 mb-5">
    <div class="row g-2 row-cols-2 row-cols-md-5">
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalLessonsRemainingPaid }}</div>
            <div class="summary-label">Lessons Remaining (Paid)</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalValuePaidRemaining.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Value Paid Remaining</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalLessonsRemainingUnpaid }}</div>
            <div class="summary-label">Lessons Remaining (Unpaid)</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalValueUnpaidRemaining.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Value Unpaid Remaining</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalValueRemaining.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Total Value of Remaining Lessons</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalBalanceDueLessons.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Balance Due (Lessons Only)</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalOwedForServices.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Owed for Services Given</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalPaidAhead.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Received in Advance</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalExpiredValue.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">Value of Expired Lessons</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-xl">
        <mat-card class="summary-card total-liability h-100">
          <mat-card-content>
            <div class="summary-number">{{ totalLiability.toFixed(2) | studioCurrency }}</div>
            <div class="summary-label">NET LIABILITY</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Detailed Liability Table -->
  <div class="container-fluid">
    <div class="table-responsive-sticky table-responsive">
      <h2 *ngIf="liabilityData?.length > 0">Detailed Student Liability</h2>
      <table mat-table [dataSource]="dataSource" matSort
             (matSortChange)="sortDataView($event)"
             class="mat-elevation-z8 mat-table">

        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.studentName }}</td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold">Grand Total</td>
        </ng-container>

        <!-- NOTE: column render order is driven by displayedColumns in the TS,
             not by the order of these defs. -->

        <!-- Lessons Remaining (Paid) Column -->
        <ng-container matColumnDef="lessonsRemainingPaid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Paid
            <mat-icon class="help-icon-inline" matTooltip="Of the lessons this student still has left to take, how many are already paid for. These are lessons the studio has collected money for but still owes the student.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-center">{{ row.lessonsRemainingPaid || 0 }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-center fw-bold">{{ totalLessonsRemainingPaid }}</td>
        </ng-container>

        <!-- Value of Paid Remaining Column -->
        <ng-container matColumnDef="valuePaidRemaining">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            $ Value
            <mat-icon class="help-icon-inline" matTooltip="The dollar value of the lessons this student has already paid for but not yet taken. This is the amount of prepaid service the studio still owes in lessons.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.valuePaidRemaining || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalValuePaidRemaining | studioCurrency }}</td>
        </ng-container>

        <!-- Lessons Remaining (Unpaid) Column -->
        <ng-container matColumnDef="lessonsRemainingUnpaid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Unpaid
            <mat-icon class="help-icon-inline" matTooltip="Of the lessons this student still has left to take, how many have not yet been paid for. These are lessons the studio must still teach and still needs to collect money for.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-center">{{ row.lessonsRemainingUnpaid || 0 }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-center fw-bold">{{ totalLessonsRemainingUnpaid }}</td>
        </ng-container>

        <!-- Value of Unpaid Remaining Column -->
        <ng-container matColumnDef="valueUnpaidRemaining">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            $ Value
            <mat-icon class="help-icon-inline" matTooltip="The dollar value of the lessons this student still has left to take but has not yet paid for. This is money the studio is still owed for future lessons.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.valueUnpaidRemaining || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalValueUnpaidRemaining | studioCurrency }}</td>
        </ng-container>

        <!-- Total Value of Remaining Lessons Column -->
        <ng-container matColumnDef="totalValueRemaining">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            Total Value of Remaining Lessons
            <mat-icon class="help-icon-inline" matTooltip="Paid value plus unpaid value of this student's remaining lessons.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.totalValueRemaining || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalValueRemaining | studioCurrency }}</td>
        </ng-container>

        <!-- Actual Balance Due (Lessons Only) Column -->
        <ng-container matColumnDef="balanceDueLessons">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            Actual Balance Due (Lessons Only)
            <mat-icon class="help-icon-inline" matTooltip="Money still owed on lesson enrollments. Misc purchases are not included.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.balanceDueLessons || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalBalanceDueLessons | studioCurrency }}</td>
        </ng-container>

        <!-- $ Owed for Services Given Column -->
        <ng-container matColumnDef="owedForServices">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            $ Owed for Services Given
            <mat-icon class="help-icon-inline" matTooltip="The value of lessons already delivered that payments have not covered yet, money owed to the studio for services given.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.owedForServices || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalOwedForServices | studioCurrency }}</td>
        </ng-container>

        <!-- Value of Expired Lessons Column -->
        <ng-container matColumnDef="expiredValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            Value of Expired Lessons
            <mat-icon class="help-icon-inline" matTooltip="Value of remaining lessons on enrollments whose expiration date has passed. Enrollments without an expiration date never expire.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.expiredValue || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalExpiredValue | studioCurrency }}</td>
        </ng-container>

        <!-- Received in Advance Column -->
        <ng-container matColumnDef="paidAhead">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            $ Received in Advance
            <mat-icon class="help-icon-inline" matTooltip="Money received for lessons not yet delivered: the value of remaining lessons minus the balance still owed. Lessons only, misc purchases are not included.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ (row.paidAhead || 0) | studioCurrency }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-end fw-bold">{{ totalPaidAhead | studioCurrency }}</td>
        </ng-container>

        <!-- Net Liability Column -->
        <ng-container matColumnDef="totalLiability">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
            Net Liability ($)
            <mat-icon class="help-icon-inline" matTooltip="Received in advance, minus money owed for services given, minus the value of expired lessons. Negative means the student owes the studio more than the studio owes them. Rows at or beyond $1,000 either way are highlighted.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" class=" liability-amount text-end">
            <strong>{{ (row.totalLiability || 0) | studioCurrency }}</strong>
          </td>
          <td mat-footer-cell *matFooterCellDef class="liability-amount text-end fw-bold">{{ totalLiability | studioCurrency }}</td>
        </ng-container>

        <!-- Group header row (first tier): "# of Lessons Remaining" spans the four
             paid/unpaid columns; the other cells are blank spacers. -->
        <ng-container matColumnDef="group-student">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="1"></th>
        </ng-container>
        <ng-container matColumnDef="group-lessons-remaining">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="text-center">
            # of Lessons Remaining
          </th>
        </ng-container>
        <ng-container matColumnDef="group-rest">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="6"></th>
        </ng-container>

        <!-- Pagination footer column: keeps the paginator always mounted so the
             @ViewChild(MatPaginator) resolves even when there are zero rows. -->
        <ng-container matColumnDef="pagination-footer">
          <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
            <mat-paginator (page)="pageChanged($event)"
                           [disabled]="ShowProgressBar"
                           [pageSizeOptions]="onPageSizeOptions()"
                           [length]="30"
                           [pageSize]="paginationTotalPages"
                           [pageIndex]="paginationIndex"
                           showFirstLastButtons
                           aria-label="Select page of liability data"></mat-paginator>
          </td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="groupHeaderColumns; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.high-liability]="row.totalLiability >= 1000 || row.totalLiability <= -1000"></tr>
        <!-- Grand Total row: server full-set totals (all matching students), not
             a sum of the visible page slice. Hidden when there are no rows. -->
        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"
            class="grand-total-row"
            [hidden]="!liabilityData?.length"></tr>
        <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <ng-container *ngIf="!ShowProgressBar">No liability data found for the selected criteria</ng-container>
          </td>
        </tr>
      </table>
    </div>

    <!-- No Data Message -->
    <div *ngIf="!liabilityData?.length && !ShowProgressBar" class="text-center mt-5">
      <mat-icon style="font-size: 48px; color: #ccc;">info</mat-icon>
      <h3>No Liability Data Found</h3>
      <p>There are no students with liability for the selected criteria.</p>
    </div>
  </div>

  <!-- Spacing for the bottom of the page -->
  <div class="mt-4" style="height: 100px;"></div>
</div>
